import { gsap, Linear, Back, Power1 } from "gsap";

let density = 40;
let speed = 3;
let start = {
    yMin: -100,
    yMax: 0,
    xMin: -25,
    xMax: 25,
    scaleMin: 0.1,
    scaleMax: 0.25,
    scaleXMin: 1,
    scaleXMax: 1,
    scaleYMin: 1,
    scaleYMax: 1,
    opacityMin: 0.1,
    opacityMax: 0.4
};
let mid = {
    yMin: -400,
    yMax: 0,
    xMin: -140,
    xMax: 140,
    scaleMin: 0.2,
    scaleMax: 0.8,
    opacityMin: 0.5,
    opacityMax: 1
};
let end = {
    yMin: -800,
    yMax: 0,
    xMin: -300,
    xMax: 300,
    scaleMin: 0.1,
    scaleMax: 1,
    opacityMin: 0.4,
    opacityMax: 0.7
};

function range(map, prop)
{
    let min = map[prop + 'Min'], max = map[prop + 'Max'];
    return min + (max - min) * Math.random();
}

function randomEase(easeThis, easeThat)
{
    if (Math.random() < 0.5) return easeThat;
    return easeThis;
}

function spawn(particle)
{
    let wholeDuration = (10 / speed) * (0.7 + Math.random() * 0.4),
        delay = wholeDuration * Math.random(),
        partialDuration = (wholeDuration + 1) * (0.2 + Math.random() * 0.3);

    gsap.set(particle,
    {
        y: range(start, 'y'),
        x: range(start, 'x'),
        scaleX: range(start, 'scaleX'),
        scaleY: range(start, 'scaleY'),
        scale: range(start, 'scale'),
        opacity: range(start, 'opacity'),
        visibility: 'hidden'
    });

    gsap.to(particle,
    {
        duration: partialDuration,
        delay: delay,
        y: range(mid, 'y'),
        ease: randomEase(Linear.easeOut, Back.easeInOut)
    });

    gsap.to(particle,
    {
        duration: wholeDuration - partialDuration,
        delay: partialDuration + delay,
        y: range(end, 'y'),
        ease: Back.easeIn
    });
    //Moving on axis X
    gsap.to(particle,
    {
        duration: partialDuration,
        delay: delay,
        x: range(mid, 'x'),
        ease: Power1.easeOut
    });

    gsap.to(particle,
    {
        duration: wholeDuration - partialDuration,
        delay: partialDuration + delay,
        x: range(end, 'x'),
        ease: Power1.easeIn
    });

    partialDuration = wholeDuration * (0.5 + Math.random() * 0.3);
    gsap.to(particle,
    {
        duration: partialDuration,
        delay: delay,
        scale: range(mid, 'scale'),
        autoAlpha: range(mid, 'opacity'),
        ease: Linear.easeNone
    });

    gsap.to(particle,
    {
        duration: wholeDuration - partialDuration,
        delay: partialDuration + delay,
        scale: range(end, 'scale'),
        autoAlpha: range(end, 'opacity'),
        ease: Linear.easeNone,
        onComplete: purge,
        onCompleteParams: [particle]
    });
}

function purge(particle) { particle.remove(); }

export const Sparks = {
    createParticle: () =>
    {
        let i, particleSpark;
        for (i = 0; i < density; i += 1)
        {
            particleSpark = document.createElement('div');
            particleSpark.classList.add('spark');
            let screen = document.getElementById('layer1');
            screen.appendChild(particleSpark);
            spawn(particleSpark);
        }
    }
}

